import { CartDiscountField } from 'theme';

class CartDiscountApplyField extends CartDiscountField {
	connectedCallback() {
		this.codeInput = this.querySelector('input:not([type="hidden"])');
		this.applyButton = this.querySelector('.cart-discount-apply-field__button');

		if (!this.codeInput || !this.applyButton) {
			return;
		}

		this.abortController = new AbortController();
		const { signal } = this.abortController;

		this.applyButton.addEventListener('click', this.applyCode.bind(this), { signal });
		this.codeInput.addEventListener('keydown', this.handleCodeKeydown.bind(this), { signal });
	}

	disconnectedCallback() {
		this.abortController?.abort();
	}

	get isBusy() {
		return this.getAttribute('aria-busy') === 'true';
	}

	async toggleDiscount(event) {
		if (event.type === 'change') {
			return;
		}

		await super.toggleDiscount(event);
	}

	handleCodeKeydown(event) {
		if (event.key !== 'Enter') {
			return;
		}

		event.preventDefault();
		this.applyCode();
	}

	async applyCode() {
		if (this.isBusy) {
			return;
		}

		if (this.codeInput.value.trim() === '') {
			this.codeInput.focus();
			return;
		}

		try {
			await super.toggleDiscount({ currentTarget: this, target: this.codeInput });
		} catch (error) {
			this.setAttribute('aria-busy', 'false');
			this.dispatchEvent(new CustomEvent('cart:discount:error', { bubbles: true }));
		}
	}
}

if (!window.customElements.get('cart-discount-apply-field')) {
	window.customElements.define('cart-discount-apply-field', CartDiscountApplyField);
}
